import { render, staticRenderFns } from "./SearchDialog.vue?vue&type=template&id=2f707d6f&scoped=true&"
import script from "./SearchDialog.vue?vue&type=script&lang=js&"
export * from "./SearchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f707d6f",
  null
  
)

export default component.exports